import { FichierModelInput, OptionsVignettesOptionsModel } from 'src/graphql/generated-types';

export class AppFile {
    /**
     * The file that should be uploaded
     */
    file: File;

    /**
     * The file blob
     */
    fileBlob: string;

    /**
     * File extension
     */
    extension: string;

    constructor(file: File, fileBlob: string, extension?: string) {
        this.file = file;
        this.fileBlob = fileBlob;
        this.extension = extension;
    }
}

/**
 * Returns a `FichierModel` from a given type.
 * It should be used when we want to save a picture.
 */
export function createNewFile(file: AppFile | OptionsVignettesOptionsModel, mode: 'withoutContentType' | 'withContentType' = 'withoutContentType'): FichierModelInput {
    let newFile: FichierModelInput;

    if (file instanceof AppFile) {
        newFile = {
            FileBytes: mode === 'withoutContentType'
                ? file.fileBlob.split(',')[1]
                : file.fileBlob,
            Filename: file.file.name,
            Extension: file.extension,
            Url: file.fileBlob
        };
    } else {
        newFile = {
            IdFile: file.IdFile,
            Filename: file.Libelle,
            Token: file.Token,
            Extension: file.Extension,
            Url: file.Url,
        };
    }

    return newFile;
}

/////////////////////// START DOWNLOAD /////////////////

type stringOrCallback = string | (() => string);
type downloadParams = {fileName: string, url: stringOrCallback, locationUrl?: stringOrCallback};

// convert string or callback to string
function toString(value: stringOrCallback): string {
    return typeof value === 'function' ? value() : value;
}

/**
 * download : url and locationUrl could be string or callback, to reduce memory usage on hudge file
 */

export function download({fileName, url, locationUrl}: downloadParams){
    locationUrl = locationUrl || url;

    const a = document.createElement('a');
    if (URL && 'download' in a) {
        a.href = toString(url);
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } else {
        location.href = toString(locationUrl);
    }
}

/**
 * download a file
 * exemple : downloadFile(csvContent, fileName, 'text/csv;charset=utf-8;encoding:utf-8');
 * https://stackoverflow.com/a/29304414
 */
export function downloadFile(content: string, fileName: string, mimeType: string) {
    const blob = new Blob([content], {type: mimeType});
    download({
        fileName,
        url: () => URL.createObjectURL(blob),
        locationUrl: () => 'data:application/octet-stream,' + encodeURIComponent(content)
    });
}

export function downloadFromUrl(url: string, fileName: string){
    download({fileName, url});
}

/////////////////////// END DOWNLOAD ////////////////////

export const FileSizeSIUnits = ['octets', 'Ko', 'Mo', 'Go', 'To'];

/**
 * Formate la taille du fichier pour l'affichage
 * @param startFrom l'unité correspondant à la valeur de départ
 */
export function formatFileSize(fileSize: number, startFrom: string = 'octets'): string {
    if (fileSize === 0) {
        return '0 octets';
    }

    // Si on veut gérer les KibiOctet ajouter une condition pour affecter 1024 à la place
    const kilo = 1000;

    // On détermine l'unité qui seras utilisé
    const i = Math.floor(Math.log(fileSize) / Math.log(kilo));

    return parseFloat((fileSize / Math.pow(kilo, i)).toFixed(2)) + ' ' + FileSizeSIUnits[i + (FileSizeSIUnits.indexOf(startFrom) || 0)];
}
